import { FAQ_ROUTE_API } from '../constants';
import { apiClient } from '../utils/Api';
import { logout } from './authAction';

const FAQ_REQUEST_TIMEOUT = 15000;

// Return data to the picker without overwriting the FAQ management page's Redux state.
const requestFaq = (path, config) => async dispatch => {
  try {
    const response = await apiClient().get(path, {
      ...config,
      timeout: FAQ_REQUEST_TIMEOUT,
    });
    return response.data.data;
  } catch (error) {
    if (error.response && error.response.status === 401) dispatch(logout());
    throw error;
  }
};

export const fetchSliderFaqs = (params, cancelToken) => requestFaq(FAQ_ROUTE_API, {
  params: { ...params, active: 1 },
  cancelToken,
});

export const fetchSliderFaq = (id, cancelToken) => requestFaq(`${FAQ_ROUTE_API}/${id}`, {
  cancelToken,
});
